module.exports = __webpack_public_path__ + "static/media/queen-of-atlantis.1a4fc0c8.gif";